import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import joi from 'joi';
import { joiPasswordExtendCore } from 'joi-password';
import TextField from '@mui/material/TextField';

const joiPassword = joi.extend(joiPasswordExtendCore);

const Password = (props) => {
	const {
		disabled,
		errors,
		id,
		label,
		onInputChange,
		onInputFocus,
		required,
		value,
		...styleProps
	} = props;
	const schemaDefinition = {};
	const { t } = useTranslation('inputs');

	schemaDefinition[id] = joiPassword
		.string()
		.min(8)
		.minOfSpecialCharacters(1)
		.minOfLowercase(1)
		.minOfUppercase(1)
		.minOfNumeric(1)
		.noWhiteSpaces()
		.required();

	const schema = joi.object(schemaDefinition);

	const handleErrorText = () => {
		if (!errors?.[id]) {
			return null;
		}

		return errors[id];
	};

	const handleOnChange = (e) => {
		onInputChange(e.target.value, id, schema);
	};

	return (
		<TextField
			disabled={disabled}
			{...styleProps}
			sx={{ flex: 1, color: 'purple' }}
			name={id}
			label={label || t('password.value')}
			onChange={handleOnChange}
			onFocus={onInputFocus}
			size="small"
			slotProps={{
				inputLabel: {
					shrink: true
				}
			}}
			type="password"
			helperText={handleErrorText()}
			error={!!errors?.[id]}
			defaultValue={value || ''}
		/>
	);
};

Password.propTypes = {
	disabled: PropTypes.bool,
	errors: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	id: PropTypes.string.isRequired,
	label: PropTypes.string,
	onInputChange: PropTypes.func,
	onInputFocus: PropTypes.func,
	required: PropTypes.bool,
	value: PropTypes.string
};

export default Password;
